import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../Components/TopMenu/TopMenu';

import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import AssetsIcon from '../../../assets/images/oparation.svg';
import AssetsIconw from '../../../assets/images/oparation_a.svg';

import EInStock from './Components/ImportInstock';
import Expected from './Components/Expected';
import Release from './Components/Release';
import Delivered from './Components/Delivered'; 

const Import = () => {
  const keysToRemove = ['Ftab_inbound', 'Ftab_planning', 'Ftab_export', 'Ftab_shprec'];
  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
  });
  const initialTab = localStorage.getItem("Ftab_import") || 'expected';
  const isMounted = useRef(false);
  const [selectedButton, setSelectedButton] = useState(initialTab);
  const [apiNumber, setApiNumber] = useState(null);
  const [msgCount, setMsgCount] = useState();

  useEffect(() => {
    setSelectedButton(initialTab);
  }, [initialTab]);
  // console.log('555', selectedButton);
  const handleButtonClick = (button) => {
    setSelectedButton(button);
    localStorage.setItem('Ftab_import', button);
    localStorage.removeItem('link_mawb')
  };
  return (
    <>
      <div className="">
        <Header page_type='fsm' logo_url='/ForwarderShipments/Import' />
        <div className="page-body-wrapper schedule">
          <LeftMenu />
          <div className="main-panel rounded">
            <div className="mainTab">
              <TopMenu module='FSHPMNGR' />
              <div className="">
                <div className="allcontent-fl">
                  <div className='d-flex justify-content-between mb-3'>
                    <div>
                      <button className={selectedButton === 'expected' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('expected')}>
                        <img src={selectedButton === 'expected' ? AssetsIconw : AssetsIcon} /> <span>Expected</span>
                      </button>
                      <button className={selectedButton === 'instock' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('instock')}>
                        <img src={selectedButton === 'instock' ? AssetsIconw : AssetsIcon} /> <span>In Stock</span>
                      </button>
                      <button className={selectedButton === 'release' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('release')}>
                        <img src={selectedButton === 'release' ? AssetsIconw : AssetsIcon} /> <span>Release</span>
                      </button>
                      <button className={selectedButton === 'delivered' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('delivered')}>
                        <img src={selectedButton === 'delivered' ? AssetsIconw : AssetsIcon} /> <span>Delivered</span>
                      </button>
                    </div>
                    <div className='search'>
                      <div className="form-group has-search">

                        {/* <ReactSearchAutocomplete
                                                    items={searchItems}
                                                    onSearch={handleOnSearch}
                                                    onHover={handleOnHover}
                                                    onSelect={handleOnSelect}
                                                    onFocus={handleOnFocus}
                                                    autoFocus
                                                    placeholder="Search ULD"
                                                // formatResult={formatResult}
                                                /> */}
                      </div>
                    </div>
                  </div>
                  <div className="lcontent">
                    {selectedButton === 'expected' && <Expected />}
                    {selectedButton === 'instock' && <EInStock />}
                    {selectedButton === 'release' && <Release />}
                    {selectedButton === 'delivered' && <Delivered />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Import